import React, { useState } from "react";
import Modal from "../../components/Modal/Modal";
import itinerary from "../../assets/images/itinerario.webp";
import program1 from "../../assets/images/program1.webp";
import program3 from "../../assets/images/program2.webp";
import program4 from "../../assets/images/program3.webp";
import program5 from "../../assets/images/program4.webp";
import program6 from "../../assets/images/program5.webp";
// import program7 from "../../assets/images/program6.webp";
import program8 from "../../assets/images/program7.webp";
import program9 from "../../assets/images/program8.webp";

import "./program.css";

const Program = () => {
  const [active, setActive] = useState(1);
  const [isModalVisible, setIsModalVisible] = useState(false);

  return (
    <section className="program__container">
      <div className="program__content content__page">
        <div className="divider">
          <span></span>
        </div>
        <div id="program" className="program__title">
          <h2>PROGRAMA</h2>
        </div>
        <div className="program__tabs">
          <div className="select-btns">
            <a
              href="#programation"
              onClick={() => setActive(1)}
              className={active === 1 ? "active" : ""}
            >
              <p>Dias 27 a 31 de março</p>
            </a>

            <a
              href="#programation"
              onClick={() => setActive(2)}
              className={active === 2 ? "active" : ""}
            >
              <p>Dia 2 de abril</p>
            </a>

            <a
              href="#programation"
              onClick={() => setActive(3)}
              className={active === 3 ? "active" : ""}
            >
              <p>Dia 3 de abril</p>
            </a>

            <a
              href="#programation"
              onClick={() => setActive(4)}
              className={active === 4 ? "active" : ""}
            >
              <p>Dia 27 de abril</p>
            </a>

            {/* <a
              href="#programation"
              onClick={() => setActive(5)}
              className={active === 5 ? "active" : ""}
            >
              <p>Dia 5 de maio</p>
            </a> */}

            {/* <a
              href="#programation"
              onClick={() => setActive(7)}
              className={active === 7 ? "active" : ""}
            >
              <p>Dia 29 de julho <span className="thin">(adiado)</span></p>
            </a> */}

            <a
              href="#programation"
              onClick={() => setActive(6)}
              className={active === 6 ? "active" : ""}
            >
              <p>Dia 11 de outubro</p>
            </a>


            <a
              href="#programation"
              onClick={() => setActive(8)}
              className={active === 8 ? "active" : ""}
            >
              <p>Dia 2 de novembro</p>
            </a>

            <a
              href="#programation"
              onClick={() => setActive(9)}
              className={active === 9 ? "active" : ""}
            >
              <p>Dia 3 de novembro</p>
            </a>
          </div>
        </div>
        <div className="program__content-days">
          <div id="programation" className="programation">
            {active === 1 && (
              <div className="program__info">
                <h4> De 27 a 31 de março</h4>
                <p>
                  Visita dos alunos do 4º, 6º e 9º anos dos agrupamentos de
                  Escolas do Concelho de Ílhavo.
                </p>
              </div>
            )}
            {active === 2 && (
              <div className="program__info">
                <h4> Dia 2 de abril</h4>
                <p>
                  No ano em que comemora 215 anos da Abertura da Barra, o Porto
                  de Aveiro volta a abrir as suas portas à população.<br /><br />
                  Com esta iniciativa pretendemos, não só, dar a conhecer as principais
                  áreas portuárias, mas, também, mostrar a importância que o
                  Porto de Aveiro tem para o desenvolvimento da região onde se
                  insere.
                  <br />
                </p>
              </div>
            )}
            {active === 3 && (
              <div className="program__info">
                <h4> Dia 3 de abril</h4>
                <p>
                  Cerimónia Comemorativa dos 215 anos da Abertura da Barra do
                  Porto de Aveiro. <br /><br />Evento dedicado à comunidade portuária.
                </p>
              </div>
            )}
            {active === 4 && (
              <div className="program__info">
                <h4> Dia 27 de abril</h4>
                <p>
                Seminário Internacional - “Crescimento Ferroviário no Corredor Ibérico – Desafios e Oportunidades”
                  <br />
                  <br />
                  Inauguração do Topónimo “Avenida de Salamanca”
                </p>
              </div>
            )}
            {/* {active === 5 && (
              <div className="program__info">
                <h4> Dia 5 de maio </h4>
                <p>
                Visita ao Porto de  Aveiro – Comunidades Intermunicipais <br />
                  <br />
                </p>
              </div>
            )} */}
            {active === 6 && (
              <div className="program__info">
                <h4>Dia 11 de outubro </h4>
                <p>Seminário: "Os Portos - Alavanca da Economia Regional".</p>
              </div>
            )}
            {/* {active === 7 && (
              <div className="program__info">
                <h4> Dia 29 de julho <span className="thin-info">- adiado para data ainda a definir</span></h4>
                <p>Projeção de Video Mapping no Farol da Barra.</p>
              </div>
            )} */}
            {active === 8 && (
              <div className="program__info">
                <h4> Dia 2 de novembro</h4>
                <p>
                Lançamento de livro evocativo dos trabalhadores do Porto de Aveiro, dos últimos 100 anos.
                </p>
              </div>
            )}
            {active === 9 && (
              <div className="program__info">
                <h4> Dia 3 de novembro </h4>
                <p>
                Cerimónia Evocativa dos 25 anos da APA, S.A.
                </p>
              </div>
            )}
          </div>
          {active === 1 && (
            <div className="illustration">
              <img src={program1} alt="Porto de Aveiro - 215 anos" />
            </div>
          )}

          {active === 2 && (
            <div className="subscription">
              <p>
              A visita será efetuada de autocarro (gratuito) nos seguintes horários:
              </p>
              <ol>
                <li>
                  1º Turno: <span>10h00</span>
                </li>
                <li>
                  2º Turno: <span>15h00</span>
                </li>
              </ol>
              <p>Prazo limite de inscrição: dia 30 de março</p><br />
              <p><strong>Inscrições limitadas ao número de lugares do autocarro.</strong></p>
              <p>&nbsp;</p>
              {/* <button onClick={() => setIsModalVisible(true)}>Inscrição</button> */}
            </div>
          )}
          {active === 3 && (
            <div className="illustration">
              <img src={program3} alt="Porto de Aveiro - 215 anos" />
            </div>
          )}
          {active === 4 && (
            <div className="illustration">
              <img src={program4} alt="Porto de Aveiro - 215 anos" />
            </div>
          )}
          {active === 5 && (
            <div className="illustration">
              <img src={program5} alt="Porto de Aveiro - 215 anos" />
            </div>
          )}
          {active === 6 && (
            <div className="illustration">
              <img src={program6} alt="Porto de Aveiro - 215 anos" />
            </div>
          )}
          {/* {active === 7 && (
            <div className="illustration">
              <img src={program7} alt="Porto de Aveiro - 215 anos" />
            </div>
          )} */}
          {active === 8 && (
            <div className="illustration">
              <img src={program8} alt="Porto de Aveiro - 215 anos" />
            </div>
          )}
          {active === 9 && (
            <div className="illustration">
              <img src={program9} alt="Porto de Aveiro - 215 anos" />
            </div>
          )}
          {isModalVisible && <Modal onClose={() => setIsModalVisible(false)} />}
        </div>
        {active === 2 && (
          <div className="itinerary">
            <div>
              <h4>Itinerário</h4>
              <img src={itinerary} alt="Itinerário" />
            </div>
          </div>
        )}
      </div>
    </section>
  );
};

export default Program;
